import styled, { css } from 'styled-components';
import Input from '../../../components/Input';
import { TextLink } from '../../../components/LinkStyles';
import { DefaultIcon } from '../../../components/Icon';

export const WalletsContainerDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  div:last-child {
    margin-right: auto;
  }
`;

export const WalletWrapperDiv = styled.div`
  margin-top: 0.65rem;
  margin-bottom: 0.65rem;
  height: 14.3rem;
  width: calc(100% - 1.35rem);
  background-color: ${props => props.theme.white};
  ${props => props.theme.defaultDropShadow};
  padding: 3.5rem 2.7rem 1.5rem 2.7rem;
  :hover {
    outline: 1px solid ${props => props.theme.blue};
  }
  @media screen and (min-width: 768px) {
    margin-left: 0.65rem;
    margin-right: 0.65rem;
    width: calc(50% - 1.35rem);
  }
  @media screen and (min-width: 1440px) {
    width: calc(33% - 1.35rem);
    :last-of-type {
      margin-left: 1.35rem;
    }
  }
`;

export const WalletContentDiv = styled.div`
  display: flex;
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid ${props => props.theme.mercury};
`;

export const WalletP = styled.p`
  color: ${props => props.theme.dustyGray};
  font-size: 1.3rem;
  line-height: 1.9rem;
`;

export const WalletActionSpan = styled.span`
  color: ${props => props.theme.blue};
  text-decoration: underline;
`;

export const CurrencyH4 = styled.h4`
  padding-left: 0.7rem;
`;

export const DescriptionWrapperDiv = styled.div`
  width: calc(100% - 1.35rem);
  margin: auto;
  margin-bottom: 5.3rem;
  @media screen and (min-width: 768px) {
    margin: 0;
    margin-right: 3rem;
  }
`;

export const AddressInput = styled(Input)`
  margin: 0;
`;

export const HeaderDiv = styled.div`
  margin-bottom: 1.8rem;
  @media screen and (min-width: 768px) {
    display: flex;
    margin-left: 0.65rem;
    margin-right: 0.65rem;
  }
`;

export const CryptoWalletsTextDiv = styled.div`
  display: inline-block;
  p {
    line-height: 1.9rem;
  }
  color: ${props => props.theme.dustyGray};
  ${TextLink} {
    font-size: 1.3rem;
  }
`;

// ExtWalletInput
export const ExtWalletDiv = styled.div`
  position: relative;
  /* width: 85%; */
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    /* width: 23rem; */
  }
  /* ${props =>
    props.theme.sidebarOpened &&
    css`
      @media screen and (max-width: 1199px) {
        width: 28rem;
      }
    `} */
  svg {
    /* position: absolute; */
    /* left: calc(100% + 1rem);
    bottom: 0.8rem; */
    margin-left: 8px;
    height: 1.1rem;
    fill: ${props => props.theme.blue};
  }
`;

export const ExtWalletLabel = styled.label`
  display: block;
  color: black;
  font-style: normal;
  user-select: none;
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  ${props => props.theme.fontStackHeader};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ExtAddressInput = styled.input`
  font-size: 1.4rem;
  /* ${props => props.theme.fontStackHeader}; */
  font-style: normal;
  font-weight: 300;
  color: ${props => props.theme.dustyGray};
  position: relative;
  border: none;
  padding-top: 3px;
  padding-bottom: 3px;
  border-bottom: 1px solid ${props => props.theme.mercury};
  width: 100%;
  background-color: transparent !important;
  text-overflow: ellipsis;
  overflow: hidden;
  &:focus {
    outline: none;
    padding-bottom: 2px;
    border-bottom: 2px solid ${props => props.theme.blue};
  }
  &[readonly] {
    border-color: transparent;
  }
  ${props =>
    props.meta.error &&
    props.touched &&
    css`
      border-bottom-color: ${props => props.theme.red} !important;
    `}
`;

export const ExtAddressInputWrapperDiv = styled.div`
  display: flex;
`;

export const AddressErrorSpan = styled.span`
  color: ${props => props.theme.red};
  font-weight: 300;
  font-style: italic;
  text-transform: unset;
`;

export const EditLink = styled(TextLink)`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
`;

export const EyeIcon = styled(DefaultIcon)`
  margin-top: 5px;
  fill: ${props => props.theme.black} !important;
  :hover {
    fill: ${props => props.theme.blue} !important;
  }
`;
